import { GuestHeaderMetadata } from '@src/shared/components/common/guest-header-metadata';
import { Outlet } from 'react-router-dom';

// project imports

// ==============================|| MINIMAL LAYOUT ||============================== //

const MinimalLayout = () => {
  return (
    <>
      <GuestHeaderMetadata />
      <Outlet />
    </>
  );
};

export default MinimalLayout;
